import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useOryUserLogin } from '../../../../ory/hooks/oryUserLogin/useOryUserLogin';
import { IUseLoginFlowButtons, useLoginFlowButtons } from '../../hook/useLoginFlowButtons';
import { FormFieldNames, getMFAFormValidationSchema, IMFAFormData } from './validationScheme';

export interface IUseMFAForm {
  formData: UseFormReturn<IMFAFormData>;
  buttonsDirection: IUseLoginFlowButtons['buttonsDirection'];
  buttonsSpacing: IUseLoginFlowButtons['buttonsSpacing'];
  formSubmit: (data: IMFAFormData) => void;
  isOryApiFetching: boolean;
}

export interface IUseMFAFormProps {
  onSuccess?: () => void;
}

export function useMFAForm(props: IUseMFAFormProps) {
  const { formatMessage } = useIntl();
  const { buttonsDirection, buttonsSpacing } = useLoginFlowButtons();

  const { finishLoginWithSecondFactor, isOryApiFetching } = useOryUserLogin();

  const formData = useForm<IMFAFormData>({
    defaultValues: { totpCode: '' },
    mode: 'onChange',
    resolver: yupResolver(getMFAFormValidationSchema(formatMessage)),
  });

  const formSubmit = async (data: IMFAFormData) => {
    await finishLoginWithSecondFactor(
      { totp: data.totpCode },
      { fieldName: FormFieldNames.TotpCode, formData },
      props.onSuccess
    );
  };

  return {
    buttonsDirection,
    buttonsSpacing,
    formData,
    formSubmit,
    isOryApiFetching,
  };
}
